module.exports = __webpack_public_path__ + "img/huanjingganjing_image_zc.4b16dd73.png";